// extracted by mini-css-extract-plugin
module.exports = {"root":"ShutdownDesc_root__1RGpI"};